import PageHeader from '../layout/PageHeader'

/**
 * Header of a deep-analysis page: the anchor entity (the effect/research/
 * activity the analysis is scoped to). Navigation back is handled by the
 * breadcrumb, so no back button here.
 *
 * @param {object} props
 * @param {string} props.typeLabel - Anchor type shown above the title (e.g. 'Effect', 'Onderzoek')
 * @param {string} props.title - Name of the anchor entity
 * @param {string} [props.description] - Optional intro text under the title
 */
const DeepAnalysisAnchorHeader = ({ typeLabel, title, description }) => (
    <div className='deep-analysis-anchor-header'>
        <PageHeader
            heading={title}
            subHeading={typeLabel}
            description={description}
            AI={false}
        />
    </div>
)

export default DeepAnalysisAnchorHeader
